import React, { memo, useContext } from 'react';
import './css/HomePage1FeatureImagesCarousel3.css';
import { Carousel } from 'react-responsive-carousel';
import { StyleSheet, css } from 'aphrodite';
import { context } from '../../../../../../globalState/GlobalState';
import { isValidObject, isValidString } from '../../../../../../catalog/Validity';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { getWebsiteImageLink } from '../../../../../../catalog/Website';

const HomePage1FeatureImagesCarousel3 = () => {
    const { globalState } = useContext(context);

    const getCaraousel = () => {
        if (!isValidObject(globalState) || !isValidObject(globalState.websiteImages)) {
            return null;
        }
        const featureImages = [];
        const mobileFeatureImages = [];
        globalState.websiteImages.forEach((image) => {
            if (image.id === 'featureImage1') {
                if (isValidString(image.image)) {
                    featureImages.push(image);
                    mobileFeatureImages.push(image);
                }
            }
            if (image.id === 'featureImage2') {
                if (isValidString(image.image)) {
                    featureImages.push(image);
                    mobileFeatureImages.push(image);
                }
            }
            if (image.id === 'featureImage3') {
                if (isValidString(image.image)) {
                    featureImages.push(image);
                    mobileFeatureImages.push(image);
                }
            }
            if (image.id === 'mFeatureImage1') {
                if (isValidString(image.image)) {
                    mobileFeatureImages.splice(0, 1, image);
                }
            }
            if (image.id === 'mFeatureImage2') {
                if (isValidString(image.image)) {
                    mobileFeatureImages.splice(1, 1, image);
                }
            }
            if (image.id === 'mFeatureImage3') {
                if (isValidString(image.image)) {
                    mobileFeatureImages.splice(2, 1, image);
                }
            }
        });

        const styles = StyleSheet.create({
            image: {
                ':hover': {
                    cursor: 'pointer',
                },
            },
            container: {
                '@media (max-width: 1200px)': {
                    boxShadow: `0px 15px 1px ${isValidString(globalState.websiteStyles.colors.secondaryColor) ? globalState.websiteStyles.colors.secondaryColor : globalState.websiteStyles.colors.primaryColor}`,
                },
            },
        });

        const getDescription = (content) => {
            if (content.length > 85) {
                return `${content.substr(0, 85)}...`;
            }
            return content;
        };

        return (
            <>
                <Carousel className={`homepage1-feature-images-carousel3 homepage1-feature-images-carousel3-desktop ${css(styles.container)}`} showThumbs={false} autoPlay dynamicHeight={false} interval={10000} transitionTime={500} infiniteLoop showIndicators={false} showStatus={false}>
                    {
                        featureImages.map((featureImage) => {
                            return (
                                <React.Fragment key={featureImage.id}>
                                    {isValidObject(featureImage) && isValidString(featureImage.image) ? (
                                        <>
                                            {isValidString(getWebsiteImageLink(featureImage)) ? (
                                                <a href={getWebsiteImageLink(featureImage)} className={`homepage1-feature-image-container text-black text-no-underline ${css(styles.image)}`} target="_blank" rel="noreferrer">
                                                    {globalState.stylesDownloaded ? <img className="homepage1-feature-image" src={featureImage.image} loading="lazy" alt={isValidString(featureImage.title) ? featureImage.title : 'Feature Image'} /> : null}
                                                    {isValidString(featureImage.title) || isValidString(featureImage.description) ? (
                                                        <div className="homepage1-feature-title full-width p-b-10px">
                                                            {isValidString(featureImage.title) ? <h1 className="homepage1-feature-title-text alegreya-font-family font-weight-800 font-spacing-wider line-height-wide text-center-align font-size-4xl p-t-5px text-uppercase">{featureImage.title}</h1> : null}
                                                            {isValidString(featureImage.description) ? <h2 className="homepage1-feature-title-text alegreya-font-family font-weight-500 font-spacing-wider line-height-wide text-center-align font-size-l p-t-0">{featureImage.description}</h2> : null}
                                                        </div>
                                                    ) : null}
                                                </a>
                                            ) : (
                                                <div className="homepage1-feature-image-container text-black text-no-underline">
                                                    {globalState.stylesDownloaded ? <img className="homepage1-feature-image" src={featureImage.image} loading="lazy" alt={isValidString(featureImage.title) ? featureImage.title : 'Feature Image'} /> : null}
                                                    {isValidString(featureImage.title) || isValidString(featureImage.description) ? (
                                                        <div className="homepage1-feature-title full-width p-b-10px">
                                                            {isValidString(featureImage.title) ? <h1 className="homepage1-feature-title-text alegreya-font-family font-weight-800 font-spacing-wider line-height-wide text-center-align font-size-4xl p-t-5px text-uppercase">{featureImage.title}</h1> : null}
                                                            {isValidString(featureImage.description) ? <h2 className="homepage1-feature-title-text alegreya-font-family font-weight-500 font-spacing-wider line-height-wide text-center-align font-size-l p-t-0">{featureImage.description}</h2> : null}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            )}
                                        </>
                                    ) : null}
                                </React.Fragment>
                            );
                        })
                    }
                </Carousel>
                <Carousel className={`homepage1-feature-images-carousel3 homepage1-feature-images-carousel3-mobile ${css(styles.container)}`} showThumbs={false} autoPlay dynamicHeight={false} interval={10000} transitionTime={500} infiniteLoop showIndicators={false} showStatus={false}>
                    {
                        mobileFeatureImages.map((featureImage) => {
                            return (
                                <React.Fragment key={featureImage.id}>
                                    {isValidObject(featureImage) && isValidString(featureImage.image) ? (
                                        <>
                                            {isValidString(getWebsiteImageLink(featureImage)) ? (
                                                <a href={getWebsiteImageLink(featureImage)} className={`homepage1-feature-image-container text-black text-no-underline ${css(styles.image)}`} target="_blank" rel="noreferrer">
                                                    {globalState.stylesDownloaded ? <img className="homepage1-feature-image" src={featureImage.image} loading="lazy" alt={isValidString(featureImage.title) ? featureImage.title : 'Feature Image'} /> : null}
                                                    {isValidString(featureImage.title) || isValidString(featureImage.description) ? (
                                                        <div className="homepage1-feature-title full-width p-b-0">
                                                            {isValidString(featureImage.title) ? <h1 className="homepage1-feature-title-text alegreya-font-family font-weight-800 font-spacing-wider line-height-wide text-center-align font-size-4xl p-t-5px text-uppercase">{featureImage.title}</h1> : null}
                                                            {isValidString(featureImage.description) ? <h2 className="homepage1-feature-title-text alegreya-font-family font-weight-500 font-spacing-wider line-height-wide text-center-align font-size-l p-t-0">{getDescription(featureImage.description)}</h2> : null}
                                                        </div>
                                                    ) : null}
                                                </a>
                                            ) : (
                                                <div className="homepage1-feature-image-container text-black text-no-underline">
                                                    {globalState.stylesDownloaded ? <img className="homepage1-feature-image" src={featureImage.image} loading="lazy" alt={isValidString(featureImage.title) ? featureImage.title : 'Feature Image'} /> : null}
                                                    {isValidString(featureImage.title) || isValidString(featureImage.description) ? (
                                                        <div className="homepage1-feature-title full-width p-b-0">
                                                            {isValidString(featureImage.title) ? <h1 className="homepage1-feature-title-text alegreya-font-family font-weight-800 font-spacing-wider line-height-wide text-center-align font-size-4xl p-t-5px text-uppercase">{featureImage.title}</h1> : null}
                                                            {isValidString(featureImage.description) ? <h2 className="homepage1-feature-title-text alegreya-font-family font-weight-500 font-spacing-wider line-height-wide text-center-align font-size-l p-t-0">{getDescription(featureImage.description)}</h2> : null}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            )}
                                        </>
                                    ) : null}
                                </React.Fragment>
                            );
                        })
                    }
                </Carousel>
            </>
        );
    };

    return (
        <>
            {getCaraousel()}
        </>
    );
};

export default memo(HomePage1FeatureImagesCarousel3);
